<template>
  <div class="z1000">

    <footer class="z1000">
      <div class="container-fluid ">
        <div class="row  d-flex align-items-center">
          <div class="col-md-12 text-center z1000 pt-4 pt-lg-0">
            <router-link class="" to="/">
              <img
                class="img-fluid px-5 z1000 logofooter"
                src="../assets/imgs/copaprosa2025/logo-footer.png"
                alt="Copa Prosa"
              />
            </router-link>
          </div>
          

          
        </div>
      </div>
      <div class="bgdorado py-3 subfooter">
        <div class="col-md-12  text-center">
            <p class="blanco fC pt-3">
              <router-link to="/aviso-de-privacidad" class="fC blanco"
                >AVISO DE PRIVACIDAD</router-link
              >
              | PROSA 2025
            </p>
          </div>
      </div>
    </footer>

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-200px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

